var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mountIsDone)?_c('SplitterForm',{attrs:{"isEdit":_vm.isEdit,"splitterEdit":_vm.splitterEdit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }